import React, { useState, useCallback, useEffect, useRef } from "react";
import MenuSm from "../MenuSm";
import { Link, useLocation } from "react-router-dom";
import Lenis from "@studio-freight/lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Flip } from "gsap/Flip";
import "./navbar.scss";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as LugathLogoHeader } from "../../Assets/Icons/logo-t.svg";
import { ReactComponent as PromoPlayIcon } from "../../Assets/Icons/promo-play-icon.svg";
import { menuData } from "../../Services/DataService";
import Image from "../Image";
import { ReactComponent as ChevronDown } from "../../Assets/Icons/chevron-down.svg";
import { ReactComponent as LoginRegisterIcon } from "../../Assets/Icons/login_register.svg";
import { getCookie, isInViewport, setCookie } from "../../Libs/utils";
import MarqueeComponent from "../Marquee";
import anime from "animejs/lib/anime.es.js";
import CONFIG from "../../Services/ConfigService";
import LanguageSettings from "../../Services/LanguageService";
import useTranslationEncapsulated from "../../Libs/useTranslation";
const marqueeClosedByUser = getCookie(CONFIG.APP.MARQUEE_COOKIE_KEY_NAME);
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(Flip);

export default function Navbar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { locale } = useParams();
  const lenis = useRef();
  const indicatorRef = useRef();
  const { getTranslatableContent, t, i18n } = useTranslationEncapsulated();
  const languageOptions = CONFIG.APP.AVAILABLE_LANGUAGES;
  const [selectedLanguage, setSelectedLanguage] = useState(false);
  const [mode, setMode] = useState("navbar-wrapper--light");
  const [showHeader, setShowHeader] = useState(true);
  const [showSmMenu, setshowSmMenu] = useState(false);
  const [languagesAreLoaded, setLanguagesAreLoaded] = useState(false);
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [availableLanguages, setAvailableLanguages] = useState([]);

  const [logoAnime, setLogoAnime] = useState(true);
  const [y, setY] = useState(window?.scrollY ? window?.scrollY : 0);
  const [marqueeIsVisible, setMarqueeIsVisible] = useState(
    CONFIG.APP.MARQUEE_VISIBILITY &&
      (marqueeClosedByUser === "false" || marqueeClosedByUser === null)
      ? true
      : false
  );

  const initSmoothScrolling = () => {
    lenis.current = new Lenis({
      lerp: 0.4,
      smooth: false,
    });
    lenis.current.on("scroll", (params) => {
      console.log("scroll direction >>>>>", params.direction, params);
      setShowSubMenu(false);
      if (params.targetScroll > 480) {
        setShowHeader(params.direction < 0 ? true : false);
      } else {
        setShowHeader(true);
      }

      setHeaderMode();
      return ScrollTrigger.update(params);
    });

    /*gsap.ticker.add((time) => {
      lenis.current.raf(time * 1000); // Convert time from seconds to milliseconds
    });*/

    const scrollFn = (time) => {
      lenis.current.raf(time);
      requestAnimationFrame(scrollFn);
    };
    gsap.ticker.lagSmoothing(0);

    requestAnimationFrame(scrollFn);
  };

  const calculateIndicatorPos = () => {
    console.log("calculateIndicatorPos", showSubMenu);
    if (showSubMenu === false) {
      document.querySelectorAll(".js-indicator").forEach((item) => {
        item.setAttribute("style", "");
      });
    } else {
      document.querySelectorAll(".js-indicator").forEach((item) => {
        item.setAttribute("style", "");
      });
      const navBarEl = document?.querySelector(".navbar-wrapper");
      const activeItemEl = document?.querySelector(".navbar-links__item.show");
      const activeMenuEl = activeItemEl?.querySelector(".js-sub-menu-inner");
      const indicatorEl = activeMenuEl?.querySelector(".js-indicator");

      if (activeItemEl && activeMenuEl && indicatorEl) {
        const width = activeItemEl.getBoundingClientRect().width;
        const left = activeItemEl.getBoundingClientRect().left;
        const indicatorElWidth = indicatorEl.getBoundingClientRect().width;
        const modeColor = navBarEl.classList.contains("navbar-wrapper--light")
          ? "#47ccdf"
          : "#282828";
        console.log({
          width: width,
          left: left,
          indicatorElWidth: indicatorElWidth,
        });
        anime({
          targets: ".js-indicator",
          left: left - width - 20,
          width: width - 36,
          height: 4,
          duration: 300,
          backgroundColor: modeColor,
          easing: "easeInOutExpo",
        });
      }
    }
    /*if(el?.target?.classList?.contains("navbar-links__item")){
      
      document.querySelectorAll(".js-indicator").forEach((item) => {
        item.setAttribute("style", "");
      });
      
      const width = el.target.closest(".navbar-links__item").getBoundingClientRect().width;
      const left = el.target.closest(".navbar-links__item").getBoundingClientRect().left;

      console.log(left, width);
      anime({
        targets: '.js-indicator',
         translateX: 250,
        width:width / 2,
        duration:400,
        backgroundColor: '#282828',
       easing: 'easeInOutExpo'
      });

      
    } else {
      //reset position
    }*/
  };

  const onClickSelectItem = (item) => {
    setSelectedLanguage(item.code);
  };

  const getNavBarClassState = () => {
    return `navbar-wrapper ${mode} ${showHeader ? "show" : "hide"}`;
  };

  const onClickCloseMarquee = () => {
    setCookie(
      CONFIG.APP.MARQUEE_COOKIE_KEY_NAME,
      "true",
      CONFIG.APP.MARQUEE_COOKIE_EXPIRE_IN_DAYS
    );
    setMarqueeIsVisible(false);
  };

  const setHeaderMode = () => {
    const elements = [
      ...document.getElementsByClassName("js-section_nav-dark"),
    ];
    const backgroundComponents = elements.map((el) => {
      return { el: el, visibility: isInViewport(el, 75) };
    });
    if (backgroundComponents.map((i) => i.visibility).includes(true)) {
      setMode("navbar-wrapper--dark");
    } else {
      setMode("navbar-wrapper--light");
    }
  };

  useEffect(() => {
    if (pathname) {
      setTimeout(setHeaderMode(), 0);
    }
  }, [pathname]);

  useEffect(() => {
    calculateIndicatorPos();
  }, [showSubMenu]);

  useEffect(() => {
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent("scroll"));
    }, 0);
  }, []);

  useEffect(() => {
    initSmoothScrolling();
  }, []);

  useEffect(() => {
    if (selectedLanguage?.length) {
      const isEqual =
        window?.Lugath.getCurrentLanguage() === selectedLanguage.toLowerCase();
      if (!isEqual) {
        window?.Lugath?.changeLanguage(selectedLanguage.toLowerCase());
      }
      /*
      const isEqual = i18n.language === selectedLanguage.toLowerCase();
      console.log("isEqual", isEqual);
      if (!isEqual) {
        i18n.changeLanguage(selectedLanguage.toLowerCase());
        if (locale) {
          navigate(
            `/${selectedLanguage.toLowerCase()}${pathname.substring(3)}`
          );
        } else {
          navigate(`/${selectedLanguage.toLowerCase()}${pathname}`);
        }
      }*/
    }
  }, [selectedLanguage, locale]);

  useEffect(() => {
    setTimeout(() => {
      if (window?.Lugath && window?.Lugath?.initialized) {
        setSelectedLanguage(window?.Lugath?.getCurrentLanguage());
        setAvailableLanguages(
          window?.Lugath?.language?.getAvailableLanguages()
        );
        setLanguagesAreLoaded(true);
      }
    }, 1000);
  }, [window?.Lugath]);

  useEffect(() => {
    console.log("navbar", selectedLanguage, availableLanguages);
  }, [selectedLanguage, availableLanguages]);

  return (
    <>
      <MenuSm
        setshowSmMenu={setshowSmMenu}
        showSmMenu={showSmMenu ? true : false}
        availableLanguages={availableLanguages}
        selectedLanguage={selectedLanguage}
        onClickSelectItem={onClickSelectItem}
      ></MenuSm>
      <div className={getNavBarClassState()}>
        {marqueeIsVisible ? (
          <MarqueeComponent
            onClickCloseMarquee={onClickCloseMarquee}
            marqueeIsVisible={marqueeIsVisible}
          />
        ) : null}
        <div className="navbar container mx-auto">
          <div className="navbar-inner">
            <div className={`navbar-logo`}>
              <Link reloadDocument={CONFIG.APP.HARD_ROUTE_CHANGE} to="/">
                <LugathLogoHeader
                  className={`${logoAnime ? "animate" : ""} `}
                />
              </Link>
            </div>
            <div className="navbar-links">
              {menuData
                .filter((item) => item.showInDesktop === true)
                .map((link, index) => {
                  return (
                    <div
                      key={"navbar-links__item-" + index}
                      className={`navbar-links__item ${
                        showSubMenu === index ? "show" : "hide"
                      }`}
                      onMouseEnter={() => {
                        setShowSubMenu(index);
                      }}
                      onMouseMove={() => {
                        setShowSubMenu(index);
                      }}
                      onMouseLeave={() => setShowSubMenu(false)}
                    >
                      <Link
                        reloadDocument={CONFIG.APP.HARD_ROUTE_CHANGE}
                        key={link.id}
                        to={
                          link.isExternal ? { pathname: link.slug } : link.slug
                        }
                        target={link.isExternal ? "_blank" : ""}
                      >
                        {link.showIcon ? (
                          <span className="icon-login">
                            <svg
                              width="14px"
                              height="19px"
                              viewBox="0 0 14 19"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.00814901,9 C3.14361795,9.00697179 0.011208729,12.2566069 0,16.270419 L0,19 L14,19 L14,16.270419 C13.9888356,12.2631905 10.8663153,9.01626338 7.00814901,9 Z M12.2520373,17.1802793 L1.74796275,17.1802793 L1.74796275,16.270419 C1.74796275,13.2577442 4.09937992,10.8154888 7,10.8154888 C9.90062008,10.8154888 12.2520373,13.2577442 12.2520373,16.270419 L12.2520373,17.1802793 Z"
                                id="Shape"
                              ></path>
                              <path
                                d="M7,8 C9.209139,8 11,6.209139 11,4 C11,1.790861 9.209139,0 7,0 C4.790861,0 3,1.790861 3,4 C3.0051207,6.20701445 4.79298555,7.9948793 7,8 Z M7,2.00232285 C7.81071061,2.0004451 8.54255402,2.48760514 8.85367009,3.23624527 C9.16478616,3.98488539 8.9937716,4.84725057 8.42051109,5.42051109 C7.84725057,5.9937716 6.98488539,6.16478616 6.23624527,5.85367009 C5.48760514,5.54255402 5.0004451,4.81071061 5.00232285,4 C5.00742636,2.89883498 5.89883498,2.00742636 7,2.00232285 Z"
                                id="Shape"
                              ></path>
                            </svg>
                          </span>
                        ) : null}
                        <span>{getTranslatableContent(link.title)} </span>
                        {link.sublinks.length > 0 ? (
                          <span className="arrow-down">
                            <ChevronDown />
                          </span>
                        ) : null}
                      </Link>
                      {link.sublinks.length > 0 ? (
                        <div
                          className={`w-full bg-white sub-menu-wrapper`}
                          onMouseLeave={() => {
                            setShowSubMenu(false);
                          }}
                        >
                          <div
                            key={"sub-menu-inner-" + index}
                            className={`sub-menu-inner js-sub-menu-inner`}
                          >
                            <div
                              className="sub-menu-inner__indicator js-indicator"
                              ref={indicatorRef}
                            ></div>
                            <div className="container mx-auto">
                              <div className={`sub-menu-inner__content`}>
                                <div className="sub-menu-inner__content-menu">
                                  <ul className="sub-menu-inner__content-menu__list">
                                    {link?.sublinks
                                      .filter(
                                        (item) => item.showInDesktop === true
                                      )
                                      .map((l, i) => {
                                        return (
                                          <li
                                            className="sub-menu-inner__content-menu__list-item__wrapper"
                                            key={l.id}
                                          >
                                            {l.isExternal ? (
                                              <a
                                                target="_blank"
                                                rel="noreferrer"
                                                className="sub-menu-inner__content-menu__list-item"
                                                onClick={() =>
                                                  setShowSubMenu(false)
                                                }
                                                href={l.slug}
                                              >
                                                {l?.showIcon || l?.showImage ? (
                                                  <div className="sub-menu-inner__content-menu__list-item__icon">
                                                    <>
                                                      {l?.showIcon ? (
                                                        <Image
                                                          width={24}
                                                          height={24}
                                                          fileName={`Assets/Icons/${l.icon}`}
                                                        />
                                                      ) : null}
                                                      {l?.showImage ? (
                                                        <Image
                                                          width={64}
                                                          height={64}
                                                          fileName={`Assets/Images/Features/${l.image}`}
                                                        />
                                                      ) : null}
                                                    </>
                                                  </div>
                                                ) : null}
                                                {l?.status ? (
                                                  <div
                                                    className={`sub-menu-inner__content-menu__list-item__content-status sub-menu-inner__content-menu__list-item__content-status--${l.status.alias}`}
                                                  >
                                                    {getTranslatableContent(
                                                      l.status.label
                                                    )}
                                                  </div>
                                                ) : null}
                                                <div className="sub-menu-inner__content-menu__list-item__content">
                                                  <div className="sub-menu-inner__content-menu__list-item__content-name">
                                                    {getTranslatableContent(
                                                      l.title
                                                    )}
                                                  </div>
                                                  <div className="sub-menu-inner__content-menu__list-item__content-desc">
                                                    {getTranslatableContent(
                                                      l.alias
                                                    )}
                                                  </div>
                                                </div>
                                              </a>
                                            ) : (
                                              <Link
                                                reloadDocument={
                                                  CONFIG.APP.HARD_ROUTE_CHANGE
                                                }
                                                className="sub-menu-inner__content-menu__list-item"
                                                target={
                                                  l.isExternal ? "_blank" : ""
                                                }
                                                onClick={() =>
                                                  setShowSubMenu(false)
                                                }
                                                to={{ pathname: l.slug }}
                                              >
                                                {l?.showIcon || l?.showImage ? (
                                                  <div className="sub-menu-inner__content-menu__list-item__icon">
                                                    <>
                                                      {l?.showIcon ? (
                                                        <Image
                                                          width={24}
                                                          height={24}
                                                          fileName={`Assets/Icons/${l.icon}`}
                                                        />
                                                      ) : null}
                                                      {l?.showImage ? (
                                                        <Image
                                                          width={64}
                                                          height={64}
                                                          fileName={`Assets/Images/Features/${l.image}`}
                                                        />
                                                      ) : null}
                                                    </>
                                                  </div>
                                                ) : null}
                                                {l?.status ? (
                                                  <div
                                                    className={`sub-menu-inner__content-menu__list-item__content-status sub-menu-inner__content-menu__list-item__content-status--${l.status.alias}`}
                                                  >
                                                    {getTranslatableContent(
                                                      l.status.label
                                                    )}
                                                  </div>
                                                ) : null}
                                                <div className="sub-menu-inner__content-menu__list-item__content">
                                                  <div className="sub-menu-inner__content-menu__list-item__content-name">
                                                    {getTranslatableContent(
                                                      l.title
                                                    )}
                                                  </div>
                                                  <div className="sub-menu-inner__content-menu__list-item__content-desc">
                                                    {getTranslatableContent(
                                                      l.alias
                                                    )}
                                                  </div>
                                                </div>
                                              </Link>
                                            )}
                                          </li>
                                        );
                                      })}
                                  </ul>
                                </div>
                                <div className="sub-menu-inner__content-promo">
                                  <div className="sub-menu-inner__content-promo__box">
                                    <div className="sub-menu-inner__content-promo__box-video">
                                      <Link
                                        reloadDocument={
                                          CONFIG.APP.HARD_ROUTE_CHANGE
                                        }
                                        to={"/tutorials"}
                                      >
                                        <PromoPlayIcon />
                                      </Link>
                                    </div>
                                    <div className="sub-menu-inner__content-promo__box-content">
                                      <div
                                        className="sub-menu-inner__content-promo__box-content__title"
                                        dangerouslySetInnerHTML={{
                                          __html: t(
                                            "Commons.Header.Menu.PromotionBanner.Title"
                                          ),
                                        }}
                                      />
                                      <div className="sub-menu-inner__content-promo__box-content__desc">
                                        {t(
                                          "Commons.Header.Menu.PromotionBanner.Description"
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
            </div>
            <div className="navbar-app-links">
              <a
                className="focus:ring-4 focus:outline-none focus:ring-blue-300"
                href={`${
                  CONFIG.APP.REGISTER_URL
                }?utm_source=${encodeURIComponent(
                  window.location.href
                )}&utm_medium=referral&utm_content=js_header_login_btn`}
                target="_blank"
                rel={"noopener"}
              >
                {t("Commons.Header.Menu.Login.Text")}
                <LoginRegisterIcon />
              </a>
            </div>

            <div className={"navbar-lang"}>
              {languagesAreLoaded ? (
                <div className="select">
                  <span className="current focus:ring-4 focus:outline-none focus:ring-blue-300">
                    <div className="option">
                      <span>{selectedLanguage}</span>
                      <span className="arrow-down">
                        <ChevronDown />
                      </span>
                    </div>
                  </span>

                  <div className="options">
                    <ul id="language-box">
                      {availableLanguages.map((option, index) => {
                        return (
                          <li
                            key={index}
                            onClick={() => onClickSelectItem(option)}
                          >
                            <div
                              className={
                                option === selectedLanguage
                                  ? `option selected`
                                  : `option`
                              }
                            >
                              <span>{option.code}</span>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              ) : (
                <div className="navbar-loading"></div>
              )}
            </div>

            <div className="navbar-toggle  lg:hidden">
              <div
                onClick={() => setshowSmMenu(!showSmMenu)}
                className="navbar-toggle--icon cursor-pointer relative"
              >
                <div className={`menu-icon ${showSmMenu ? "active" : ""}`}>
                  <div>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
